var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Headers, Http, RequestOptions, QueryEncoder, URLSearchParams } from "@angular/http";
import { Authenticator } from "./authenticator";
import { DacConfig } from "./dac-config.service";
import { Pako } from "./pako.service";
import 'rxjs/add/operator/toPromise';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
var GhQueryEncoder = /** @class */ (function (_super) {
    __extends(GhQueryEncoder, _super);
    function GhQueryEncoder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GhQueryEncoder.prototype.encodeKey = function (k) {
        k = _super.prototype.encodeKey.call(this, k);
        return k.replace(/\+/gi, '%2B');
    };
    GhQueryEncoder.prototype.encodeValue = function (v) {
        v = _super.prototype.encodeKey.call(this, v);
        return v.replace(/\+/gi, '%2B');
    };
    return GhQueryEncoder;
}(QueryEncoder));
var HTTPService = /** @class */ (function () {
    function HTTPService(_$http, _authenticator, _dacConfig, _pako // needs to be Pako
    ) {
        this._$http = _$http;
        this._authenticator = _authenticator;
        this._dacConfig = _dacConfig;
        this._pako = _pako; // needs to be Pako
        this._httpStatusSubject = new BehaviorSubject(200);
    }
    HTTPService.prototype.generateUrl = function (path, addToken) {
        if (addToken === void 0) { addToken = false; }
        // TODO: stephen I think this will have an error if the path already contained a query parameter...
        // we need to find a better way to do this.
        var url = this._dacConfig.api_url + path;
        if (addToken) {
            url += "?token=" + this._authenticator.AuthenticationToken;
        }
        return url;
    };
    /**
     * Returns an observable that sends the most recent http status code
     */
    HTTPService.prototype.currentStatus = function () {
        return this._httpStatusSubject.asObservable();
    };
    HTTPService.prototype.get = function (url, data) {
        var _this = this;
        if (!data) {
            data = {};
        }
        data.token = this._authenticator.AuthenticationToken;
        // IE 11 aggressively caches when we really don't want it to.  We fix it by introducing a cache busting solution...
        // Even though a server side header should solve this, it appears that IE11 doesn't always respect that.
        // so we lose the advantage of caching a number of get requests... but from an API we really want the most current result set
        data.cacheBuster = new Date().getTime();
        // in order to fix the improper coding of the + sign, we are going to change the url encode
        // @see https://github.com/angular/angular/issues/11058#issuecomment-247367318
        var searchParams = new URLSearchParams('', new GhQueryEncoder());
        Object.keys(data).forEach(function (v) { return searchParams.append(v, data[v]); });
        var options = new RequestOptions({ params: searchParams, withCredentials: true });
        return this._$http.get(this.generateUrl(url), options).toPromise()
            .then(function (val) {
            if (val && val.status) {
                _this._httpStatusSubject.next(val.status);
            }
            return val;
        })
            .catch(function (error) {
            if (error && error.status) {
                _this._httpStatusSubject.next(error.status);
            }
            throw error;
        });
    };
    HTTPService.prototype.post = function (url, data) {
        data.token = this._authenticator.AuthenticationToken;
        var options = new RequestOptions({ withCredentials: true });
        return this.postWithOptions(url, data, options);
    };
    HTTPService.prototype.securePost = function (url, data, securityToken) {
        // note the authentication token is different then the JWT token
        // TODO: stephen we need to look at changing this token to be a JWT.
        data.token = this._authenticator.AuthenticationToken;
        var headers = new Headers();
        headers.set("Authorization", "Bearer " + securityToken);
        var options = new RequestOptions({ withCredentials: true, headers: headers });
        return this.postWithOptions(url, data, options);
    };
    HTTPService.prototype.postWithOptions = function (url, data, options) {
        var _this = this;
        console.log("token is: ", data.token);
        return this._$http.post(this.generateUrl(url), data, options)
            .toPromise()
            .then(function (val) {
            if (val && val.status) {
                _this._httpStatusSubject.next(val.status);
            }
            return val;
        })
            .catch(function (error) {
            if (error && error.status) {
                _this._httpStatusSubject.next(error.status);
            }
            throw error;
        });
    };
    HTTPService.prototype.delete = function (url, data) {
        var _this = this;
        data = data || {};
        data.token = this._authenticator.AuthenticationToken;
        var options = new RequestOptions({ withCredentials: true, params: data });
        return this._$http.delete(this.generateUrl(url), options)
            .toPromise()
            .then(function (val) {
            if (val && val.status) {
                _this._httpStatusSubject.next(val.status);
            }
            return val;
        })
            .catch(function (error) {
            if (error && error.status) {
                _this._httpStatusSubject.next(error.status);
            }
            throw error;
        });
    };
    HTTPService.prototype.compressedPost = function (url, data, responseType) {
        var _this = this;
        if (responseType === void 0) { responseType = 'json'; }
        data.token = this._authenticator.AuthenticationToken;
        var binaryData = this._pako.gzip(JSON.stringify(data));
        var postUrl = this.generateUrl(url);
        return new Promise(function (resolve, reject) {
            var http = new XMLHttpRequest();
            http.withCredentials = true; // make sure to send http cookies.
            http.onload = function () {
                _this._httpStatusSubject.next(http.status);
                if (http.status >= 200 && http.status < 300) {
                    resolve(http.response);
                }
                else {
                    reject({
                        status: http.status,
                        statusText: http.statusText,
                        response: http.response
                    });
                }
            };
            http.onerror = function () {
                _this._httpStatusSubject.next(http.status);
                reject({
                    status: http.status,
                    statusText: http.statusText,
                    response: http.response
                });
            };
            http.open("POST", postUrl);
            http.setRequestHeader("Content-Type", "application/json");
            http.setRequestHeader("Content-Encoding", "gzip");
            http.responseType = responseType;
            http.send(binaryData);
        });
        // TODO: stephen pako returns a Uint8Array and angular2 doesn't seem to know how to handle this
        // as it attempts to treat it as a string, angular1 handled this just fine... until we have a solution here
        // we'll leave this commented out.
        // // var binaryData:ArrayBuffer = this._pako.gzip(JSON.stringify(data)).buffer;
        // var binaryData:Blob = new Blob([this._pako.gzip(JSON.stringify(data))]);
        // var headers = new Headers();
        // headers.append("Content-Type", "application/json");
        // headers.append("Content-Encoding", "gzip");
        // let optionArgs:RequestOptionsArgs = {
        //     headers: headers
        // };
        // return this._$http.post(this._dacConfig.api_url + url, binaryData, optionArgs).toPromise();
    };
    return HTTPService;
}());
export { HTTPService };



// WEBPACK FOOTER //
// ./src/app/shared/services/http.service.ts.pre-build-optimizer.js